import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Crud,
	Edit,
	Create,
	tabGuard
} from '@/router/index'

import SalesTrend from '@/components/modules/analytics/SalesTrend'
import SoldProducts from '@/components/modules/analytics/SoldProducts'
import PurchasedProducts from '@/components/modules/analytics/PurchasedProducts'
import RevenueCategories from '@/components/modules/analytics/RevenueCategories'
import AnalitycsOptions from '@/components/modules/analytics/settings/AnalitycsOptions'
import WidgetView from '@/components/modules/analytics/WidgetView'
import DashboardBuilder from '@/components/modules/analytics/DashboardBuilder'

// Sorgente unica delle tab della sezione Statistiche: alimenta sia la striscia
// di tab sia le guard di rotta. `model` e' quello dei permessi di ruolo
// (Modules/Analytics/Config/config.php).
const ANALYTICS_TABS = [
	{
		to: '/analytics/',
		text: 'Vendite',
		model: 'soldproduct',
	},
	{
		to: '/analytics/purchases/',
		text: 'Acquisti',
		model: 'purchasedproduct',
	},
	// {
	// 	to: '/analytics/salestrend/',
	// 	text: 'Fatturato Clienti',
	// },
	{
		to: '/analytics/revenuecategories/',
		text: 'Categorie Clienti',
		model: 'revenuecategory',
	},
	{
		to: '/analytics/widgets/',
		text: 'Widget',
		model: 'widget',
		setting: 'enable_report_lab',
	},
	{
		to: '/analytics/dashboards/',
		text: 'Dashboard',
		model: 'dashboardbuilder',
		setting: 'enable_report_lab',
	},
]

// La tab si cerca per `to`, non per indice: nell'elenco c'e' una voce commentata
// (salestrend) e riattivarla farebbe slittare gli indici, assegnando a ogni
// rotta il gate della tab sbagliata senza che nulla si rompa in modo visibile.
const analyticsTabGuard = to => tabGuard(ANALYTICS_TABS, ANALYTICS_TABS.find(t => t.to === to))

export const analytics = [
	{
		path: '/analytics',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: ANALYTICS_TABS,
		},
		children: [
			{
				path: '/analytics/',
				beforeEnter: analyticsTabGuard('/analytics/'),
				component: SoldProducts,
				meta: {
					title: 'Vendite'
				},
			},
			{
				path: '/analytics/purchases/',
				beforeEnter: analyticsTabGuard('/analytics/purchases/'),
				component: PurchasedProducts,
				meta: {
					title: 'Acquisti'
				},
			},
			// {
			// 	path: '/analytics/salestrend/',
			// 	beforeEnter: ifAuthenticated,
			// 	component: SalesTrend,
			// 	meta: {
			// 		title: 'Fatturato Clienti',
			// 	},
			// },
			{
				path: '/analytics/revenuecategories/',
				beforeEnter: analyticsTabGuard('/analytics/revenuecategories/'),
				component: RevenueCategories,
				meta: {
					title: 'Categorie Clienti',
				},
			},
			{
				path: '/analytics/widgets/',
				beforeEnter: analyticsTabGuard('/analytics/widgets/'),
				component: Crud,
				meta: {
					title: 'Widget',
				},
				props: {
					modelDef: 'widgets',
					actionIcon: 'equalizer',
					title: 'widgets',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/analytics/dashboards/',
				beforeEnter: analyticsTabGuard('/analytics/dashboards/'),
				component: Crud,
				meta: {
					title: 'Dashboard',
				},
				props: {
					modelDef: 'dashboards',
					actionIcon: 'mdi-view-dashboard',
					title: 'dashboards',
					styleClass: 'mb-offset'
				}
			},
		],
    },
    {
		path: '/analytics/widgets/create',
		name: 'widgets-create',
		beforeEnter: ifAuthenticated,
		component: Create,
		meta: {
			title: 'Nuovo Widget'
		},
		props: (route) => ({
			modelDef: 'widgets',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{
		path: '/analytics/widgets/:id/edit',
		name: 'widgets-edit',
		beforeEnter: ifAuthenticated,
		component: Edit,
		meta: {
			title: 'Modifica Widget'
		},
		props: (route) => ({
			modelDef: 'widgets',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/analytics/widgets/:id',
		name: 'widgets-show',
		beforeEnter: ifAuthenticated,
		component: WidgetView,
		meta: {
			title: 'Visualizza Widget'
		}
	},
	{
		path: '/analytics/dashboards/create',
		name: 'dashboards-create',
		beforeEnter: ifAuthenticated,
		component: Create,
		meta: {
			title: 'Nuova Dashboard'
		},
		props: (route) => ({
			modelDef: 'dashboards',
			defaultInput: route?.params?.defaultInput,
			redirect: route.params.redirect
		}),
	},
	{
		path: '/analytics/dashboards/:id/edit',
		name: 'dashboards-edit',
		beforeEnter: ifAuthenticated,
		component: Edit,
		meta: {
			title: 'Modifica Dashboard'
		},
		props: (route) => ({
			modelDef: 'dashboards',
			id: parseInt(route.params.id),
		}),
	},
	{
		path: '/analytics/dashboards/:id',
		name: 'dashboards-show',
		beforeEnter: ifAuthenticated,
		component: DashboardBuilder,
		meta: {
			title: 'Visualizza Dashboard'
		}
	},
    {
		path: '/settingsanalytics/',
		name: 'settingsanalytics',
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsanalytics/',
					text: 'Statistiche',
				},
			],
		},
		children: [
			{
				path: '/settingsanalytics/',
				component: AnalitycsOptions,
			},
		]
	},
]
